import React, {Component, createRef} from "react";
import DataTable from './TableBase';
import {IconButton} from "@material-ui/core";
import {withRouter} from "react-router-dom";
import mainHelper, {apiCall, formattedPrice} from "../../helpers/MainHelper";
import withPermissions from "../WithPermissions";
import Swal from "sweetalert2";
import ReactLoading from "react-loading";

class ManualInvoicesTable extends Component{

    constructor(props) {
        super(props);
        this.tableRef = createRef();
        this.state = {
            pending: true,
            deleteLoading: {}
        }
    }

    componentDidUpdate(prevProps) {
        // Status değiştiğinde tabloyu yeniden yükle
        if (prevProps.status !== this.props.status) {
            this.triggerFetch();
        }
    }

    getExtraQueryParams() {
        const { status } = this.props;
        if (status) {
            return { status: status };
        }
        return {};
    }

    triggerFetch = (page = 1, size = 10, search = '') => {
        if (this.tableRef.current) {
            this.tableRef.current.fetchData(page, size, search);
        }
    };

    handleInvoiceDetail = (invoiceID) => {
        this.props.history.push(`/manual-invoice-detail/${invoiceID}`);
    }

    handleDelete = async (id) => {
        const result = await Swal.fire({
            title: 'Silmek istediğinize emin misiniz?',
            text: "Bu işlem geri alınamaz!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Evet, sil!',
            cancelButtonText: 'Hayır, iptal et'
        });

        if (result.isConfirmed) {
            this.setState(prevState => ({
                deleteLoading: { ...prevState.deleteLoading, [id]: true }
            }));

            try {
                const response = await apiCall(`business/manual-invoice/${id}`, 'delete', null);

                this.setState(prevState => {
                    const updatedDeleteLoading = { ...prevState.deleteLoading };
                    delete updatedDeleteLoading[id];
                    return { deleteLoading: updatedDeleteLoading };
                });

                mainHelper.toastMessage(response.status, response.message);

                // Tabloyu yenile
                this.triggerFetch();
            } catch (error) {
                this.setState(prevState => ({
                    deleteLoading: { ...prevState.deleteLoading, [id]: false }
                }));
                mainHelper.toastMessage('error', error.response?.data?.message || 'Fatura silinirken hata oluştu!');
            }
        }
    };

    getStatusBadge = (status) => {
        const badges = {
            'draft': { class: 'badge-secondary', text: 'Taslak' },
            'running': { class: 'badge-primary', text: 'İşlemde' },
            'done': { class: 'badge-success', text: 'Tamamlanmış' },
            'error': { class: 'badge-danger', text: 'Hatalı' },
            'cancel': { class: 'badge-danger', text: 'İptal' },
            'unknown': { class: 'badge-warning', text: 'Diğer' }
        };
        const badge = badges[status] || badges['draft'];
        return <span className={`badge ${badge.class}`}>{badge.text}</span>;
    };

    getPaymentStatusBadge = (status) => {
        const badges = {
            'Ödenmedi': { class: 'badge-danger', icon: 'icon-close', text: 'Ödenmedi' },
            'Ödendi': { class: 'badge-success', icon: 'icon-check', text: 'Ödendi' }
        };
        const badge = badges[status] || badges['Ödenmedi'];
        return (
            <span className={`badge ${badge.class}`}>
                <i className={badge.icon}></i> {badge.text}
            </span>
        );
    };

    render() {
        const {pending, deleteLoading} = this.state;
        const {userPermissions} = this.props;
        const userHasDeletePermission = userPermissions.includes('delete invoice');

        const columns = [
            {
                name: 'Fatura No',
                selector: row => row.invoice_number,
                sortable: true,
                cell: row => (
                    <strong className="text-primary">{row.invoice_number}</strong>
                ),
            },
            {
                name: 'Müşteri',
                selector: row => row.customer?.name || row.customer?.title,
                sortable: true,
                cell: row => (
                    <div>
                        {row.customer
                            ? <>
                                {row.customer.name ?? ''} {row.customer.surname ?? ''}
                                {row.customer.title && (
                                    <>
                                        <br />
                                        <small className="text-muted">{row.customer.title}</small>
                                    </>
                                )}
                            </>
                            : <span className="text-muted">Müşteri Yok</span>}
                    </div>
                ),
                width: '200px',
            },
            {
                name: 'Tarih',
                selector: row => row.invoice_date,
                sortable: true,
                cell: row => mainHelper.dateOnlyFormat(row.invoice_date),
                width: '120px',
            },
            {
                name: 'Vade',
                selector: row => row.due_date,
                sortable: true,
                cell: row =>
                    row.due_date
                        ? mainHelper.dateOnlyFormat(row.due_date)
                        : '-',
                width: '120px',
            },
            {
                name: 'Tutar',
                selector: row => row.net_total,
                sortable: true,
                cell: row => (
                    <div style={{ textAlign: 'right' }}>
                        <strong>{formattedPrice(row.net_total)}</strong>
                        <br />
                        <small className="text-muted">{row.currency}</small>
                    </div>
                ),
                right: true,
                width: '120px',
            },
            {
                name: 'Durum',
                selector: row => row.status,
                sortable: true,
                cell: row => this.getStatusBadge(row.status),
                width: '120px',
            },
            {
                name: 'Ödeme',
                selector: row => row.payment_status,
                sortable: true,
                cell: row => this.getPaymentStatusBadge(row.payment_status),
                width: '140px',
            },
            {
                name: 'İşlem',
                button: true,
                cell: row => (
                    <>


                        {userHasDeletePermission && row.status === 'draft' && (
                            deleteLoading[row.id] ? (
                                <IconButton
                                    className="btn btn-outline-secondary"
                                    disabled
                                    style={{ marginRight: 1 }}
                                >
                                    <button
                                        type="button"
                                        className="btn btn-outline-danger btn-sm"
                                        disabled
                                    >
                                        <ReactLoading
                                            type="spin"
                                            width={'16px'}
                                            height={'16px'}
                                            color="#dc3545"
                                        />
                                    </button>
                                </IconButton>
                            ) : (
                                <IconButton
                                    className="btn btn-outline-secondary"
                                    onClick={() => this.handleDelete(row.id)}
                                    style={{ cursor: 'pointer', marginRight: 1 }}
                                >
                                    <button
                                        type="button"
                                        className="btn btn-outline-danger btn-sm"
                                    >
                                        <i className="icon-trash"></i>
                                    </button>
                                </IconButton>
                            )
                        )}
                    </>
                ),
            },
        ];


        return (
            <DataTable
                ref={this.tableRef}
                dataEndpoint={"business/manual-invoice"}
                columns={columns}
                onRowClicked={row => this.handleInvoiceDetail(row.id)}
                progressPending={pending}
                extraQueryParams={this.getExtraQueryParams()}>
            </DataTable>
        )
    }
}

export default withPermissions(withRouter(ManualInvoicesTable));
